import {
  DisciplineInput,
  AvailabilitySelect,
  LocationInput,
} from '~/components';
import JaneLogoImg from '~/assets/images/jane_logo_200.svg';
import { NavigationMenu } from './components';
import type { Location } from '~/utilities';
import { NavLink } from 'react-router-dom';
import { useAppDispatch } from '~/state';
import { clearDiscipline } from '~/state/discipline';
import { ReactElement } from 'react';
import { hasFeatureFlag } from '@janeapp/feature-flags-client';

interface SearchHeaderProps {
  discipline?: string;
  location?: Location;
  locationInput: ReactElement;
}

export const SearchHeader = ({
  discipline,
  location,
  locationInput,
}: SearchHeaderProps) => {
  const dispatch = useAppDispatch();
  return (
    <div
      data-testid="search-header"
      className="grid-area-header fixed left-0 right-0 top-0 z-20 flex flex-col items-center gap-4 border-b border-neutral-30 bg-neutral-10 p-4 md:relative md:border-r"
    >
      <div className="relative flex w-full flex-row items-center justify-center">
        <NavLink to="/" onClick={() => dispatch(clearDiscipline())}>
          <img
            src={JaneLogoImg}
            className="flex h-auto w-[50px] self-center"
            alt="Jane Logo"
            width="50"
            height="41"
          />
        </NavLink>
        <div className="absolute right-0">
          <NavigationMenu />
        </div>
      </div>
      <h1 className="sr-only">
        {discipline
          ? `Find ${discipline} practitioners in ${location || 'your area'}`
          : 'Find healthcare practitioners in your area'}
      </h1>
      <div className="flex w-full flex-col gap-2">
        <DisciplineInput />
        {hasFeatureFlag('NORTH_VANCOUVER_BETA') ? (
          locationInput
        ) : (
          <LocationInput isDisabled={false} />
        )}
        <AvailabilitySelect />
      </div>
    </div>
  );
};
